import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/main.css'
import '@/assets/base.css'
import '@/assets/base.js'
import router from './router.js'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import HeaderAll from '@/components/header.vue'
import FooterAll from '@/components/footer.vue'
import authenticatedDirective from '@/directives/AuthenticatedDirective'
import onLoadedDirective from '@/directives/OnLoadedDirective'
import * as Sentry from '@sentry/vue'
import { createSentryPiniaPlugin } from '@sentry/vue'
import { sentryBeforeSend } from '@/utils/SentryUtils'
import i18n from '@/i18n/index.js'
import { useCloudinary } from '@/composables/useCloudinary'
import '@/utils/localDriver.ts'
import { prefetchHotelSearchEnabled } from '@/composables/useHotelSearchEnabled'

// Home page: ask for the Hotels tab switch before the app mounts (the home route loads lazily), so Classic
// Search, however soon it is chosen, shows Hotels with the other tabs.
if (window.location.pathname === import.meta.env.BASE_URL) {
  prefetchHotelSearchEnabled()
}

const mode = import.meta.env.MODE
const sentryDsn = import.meta.env.VITE_SENTRY_DSN
const Vue = createApp(App)
const pinia = createPinia()

if (mode != 'development') {
  Sentry.init({
    Vue,
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: mode === 'production' ? 0.05 : 1.0,
    replaysSessionSampleRate: mode === 'production' ? 0.05 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    environment: mode,
    propagateTraceparent: true,
    beforeSend: sentryBeforeSend,
  })
  pinia.use(createSentryPiniaPlugin())
}
Vue.use(i18n)
Vue.use(pinia)
Vue.component('HeaderAll', HeaderAll)
Vue.component('FooterAll', FooterAll)
Vue.directive('authenticated', authenticatedDirective)
Vue.directive('on-loaded', onLoadedDirective)
Vue.use(useCloudinary)
Vue.use(router).use(ElementPlus).mount('#app')

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  Vue.component(key, component)
}
